module.exports = __webpack_public_path__ + "static/portfolio3d-d47502242219e6d927260c780ee2406c.jpg";